import { IContainerProps } from 'props';
import styled from 'styled-components';

export const Container = styled.div<IContainerProps>`
  width: 85%;
  max-width: 100rem;
  position: relative;
  border-radius: 15px;
  padding: 1.5rem;
  background: ${({ theme, color }) => theme.colors[color]};

  @media (max-width: 1020px) {
    width: -webkit-fill-available;
    margin: 0 1.5rem;
  }

  @media (max-width: 320px) {
    margin: 0 0.5rem;
    padding: 0.5rem;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0;

  p {
    display: flex;
    align-items: center;
    font-size: 1.3rem;
    color: ${({ theme }) => theme.colors.primary};
  }

  span {
    font-size: 1.3rem;
    padding: 0 0.5rem;
    color: ${({ theme }) => theme.colors.secondary};
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 90rem;
    max-width: 90rem;

    button {
      padding: 0;
    }

    .contentHeader {
      display: flex;
      align-items: center;
      width: 100%;
      gap: 5%;
      .companyData {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        max-width: 70%;

        .companyLabel {
          font-size: 1.7rem;
          font-weight: 600;
          color: ${({ theme }) => theme.colors.secondary};
        }
      }
      .containerUf {
        display: flex;
        width: 100%;
        max-width: 25%;
      }
    }
  }
  .body {
    display: flex;
    gap: 5%;
    width: 100%;
    max-width: 90rem;

    .containerNameCompany {
      display: flex;
      align-items: center;
      width: 100%;
      max-width: 70%;
    }
    .containerPostalCode {
      display: flex;
      width: 100%;
      max-width: 25%;
    }
  }
  .footer {
    display: flex;
    gap: 5%;
    width: 100%;
    max-width: 90rem;

    .containerAddress {
      display: flex;
      width: 100%;
      max-width: 70%;
      justify-content: space-between;
      .containerCity {
        display: flex;
        align-items: center;
        width: 100%;
        max-width: 30%;
      }
      .containerStreet {
        display: flex;
        align-items: center;
        width: 100%;
        max-width: 50%;
      }
      .containerNumber {
        display: flex;
        align-items: center;
        width: 100%;
        max-width: 8%;
      }
    }
    .containerComplement {
      display: flex;
      align-items: center;
      width: 100%;
      max-width: 25%;
    }
  }
  @media (max-width: 780px) {
    flex-direction: column;

    p {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .header {
      display: flex;
      gap: 1.5rem;
      width: 100%;
      align-items: start;
    }
    .body {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;
      max-width: 100%;
      .containerNameCompany {
        max-width: 100%;
      }
      .containerPostalCode {
        max-width: 100%;
      }
    }
    .footer {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;
      .containerAddress {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        max-width: 100%;
        .containerCity {
          max-width: 100%;
        }
        .containerStreet {
          max-width: 100%;
        }
        .containerNumber {
          max-width: 100%;
        }
      }
      .containerComplement {
        max-width: 100%;
      }
    }
  }
  @media (max-width: 570px) {
    .header {
      .contentHeader {
        flex-direction: column;
        .companyData {
          flex-direction: column;
          max-width: 100%;
        }
        .containerUf {
          justify-content: center;
          max-width: 6rem;
        }
      }
    }
  }
`;

export const ContentSummary = styled.div`
  .headerSummary {
    display: flex;
    justify-content: space-between;
    width: 100%;

    button {
      padding: 0;
      font-size: 1.7rem;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.secondary};
      background: transparent;
      border: none;
    }
  }

  .summary {
    padding: 0.5rem;

    button {
      font-size: 1.3rem;
      font-weight: 300;
      color: ${({ theme }) => theme.colors.primary};
      background: transparent;
      border: none;
    }
  }
`;
